import React from 'react';

const SampleReportIcon = ({ colour = '#2F8FFF', width = '15', height = '15' }) => {
    return (
        <svg width={width} height={height} viewBox="0 0 16 18" fill="none" xmlns="http://www.w3.org/2000/svg" style={{ color: colour }}>
            <path
                d="M3.21653 8.99834H9.1082
                   M3.21653 11.355H11.4649
                   M3.21653 13.7117H6.75153
                   M14.9999 14.89V6.64167L9.1082 0.75H3.21653
                   C2.5915 0.75 1.99208 0.998291 1.55011 1.44025
                   C1.10815 1.88221 0.859863 2.48164 0.859863 3.10667
                   V14.89C0.859863 15.515 1.10815 16.1145 1.55011 16.5564
                   C1.99208 16.9984 2.5915 17.2467 3.21653 17.2467H12.6432
                   C13.2682 17.2467 13.8677 16.9984 14.3096 16.5564
                   C14.7516 16.1145 14.9999 15.515 14.9999 14.89Z"
                stroke={colour}
                strokeWidth="1.4"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
            <path
                d="M9.10107 0.75V4.285
                   C9.10107 4.91003 9.34937 5.50946 9.79133 5.95142
                   C10.2333 6.39338 10.8327 6.64167 11.4577 6.64167H14.9927"
                stroke={colour}
                strokeWidth="1.4"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    );
};

export default SampleReportIcon;
